import React, { useCallback, useEffect, useRef, useState } from "react";
import { downloadExcel } from "react-export-table-to-excel";
import { Input, Label, Modal, ModalBody, ModalHeader, Spinner, Table } from "reactstrap";
import { useReactToPrint } from "react-to-print";
import { toast } from "react-toastify";

const PrintDoc = ({ innerRef, data }) => {
  const [dataPrint, setDataPrint] = useState([]);
  useEffect(() => {
    const rowsPerPage = 15;
    const pages = [];
    const { body } = data;
    for (let i = 0; i < body.length; i += rowsPerPage) {
      pages.push(body.slice(i, i + rowsPerPage));
    }
    setDataPrint(pages);
  }, [data]);
  return data === undefined || data === null ? (
    <></>
  ) : (
    <div className="d-none" style={{ overflow: "scroll" }}>
      <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
        {dataPrint.map((page, pageIndex) => (
          <div key={pageIndex} style={{ padding: "20px 0" }}>
            <h5>Halaman  {pageIndex + 1}</h5>
            <table style={{ width: "100%", border: "0.2mm solid #000000" }}>
              <thead>
                <tr>
                  {data.header.map((header, index) => (
                    <th key={index} style={{ border: "0.2mm solid #000000", padding: "8px", textAlign: "left" }}>
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {page.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {row.map((cell, cellIndex) => (
                      <td key={cellIndex} style={{ border: "0.2mm solid #000000", padding: "8px", textAlign: "left" }}>
                        {cell}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
            {/* Pemisahan halaman */}
            {pageIndex < dataPrint.length - 1 && (
              <div
                style={{
                  pageBreakBefore: "always",
                  height: "0",
                  paddingTop: "40px",
                }}></div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

const ExportBudgetDoc = ({ children, data = [] }) => {
  const printRef = useRef(null);
  const onBeforeGetContentResolve = useRef(null);
  const [loadingPrint, setLoadingPrint] = useState(false);
  const [modal, setModal] = useState(false);
  const [dataTabel, setDataTabel] = useState([]);
  const [excelData, setExcelData] = useState({
    header: [],
    body: [],
  });

  const reactToPrintContent = useCallback(() => {
    return printRef.current;
  }, [printRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: () => {
      return printRef.current;
    },
    documentTitle: "Task",
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  function handleDownloadExcel() {
    downloadExcel({
      fileName: "export-table-to-excel -> downloadExcel method",
      sheet: "export-table-to-excel",
      tablePayload: {
        header: excelData.header,
        body: excelData.body,
      },
    });
  }

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
    } else {
      // const allDataEmpty = data.every((item) => Array.isArray(item.data) && item.data.length === 0);

      // if (allDataEmpty) {
      //   toast.error("Ceklis dahulu data yang ingin di print", {
      //     autoClose: 3000,
      //   });
      //   setModal(false);
      // } else {
      //   setModal(true);
      // }
      setModal(true);
    }
  }, [modal, data]);

  useEffect(() => {
    setDataTabel(data);
  }, [data]);

  useEffect(() => {
    if (dataTabel.length > 0) {
      const result = {
        header: [],
        body: [],
      };

      const selectedItems = dataTabel.filter((item) => item.isSelected);
      result.header = selectedItems.map((item) => item.label);
      const numRows = selectedItems[0].data.length;
      for (let i = 0; i < numRows; i++) {
        const row = selectedItems.map((item) => item.data[i]);
        result.body.push(row);
      }

      setExcelData(result);
    }
  }, [dataTabel]);

  return (
    <>
      <button type="button" className="ms-1 me-1 btn btn-success" onClick={toggle}>
        <i className="ri-file-download-line me-1 align-bottom fs-14"></i> Export
      </button>
      <Modal id="showModalDetail" isOpen={modal} centered size="sm">
        <ModalHeader className="bg-light p-3" toggle={toggle}>
          Pengaturan Export
        </ModalHeader>
        <ModalBody>
          <>{children}</>
          {(dataTabel || []).map((item, idx) => {
            return (
              <div key={idx} className={"d-flex align-items-center justify-content-center mb-1 gap-1 form-check form-switch form-switch-custom form-switch-success col-lg-12"}>
                <Input
                  className={"form-check-input checked-all checked-method-all check-" + item + idx}
                  type="checkbox"
                  role="switch"
                  id={"check-" + item + idx}
                  checked={item.isSelected}
                  disabled={item.isSelected && dataTabel.filter((data) => data.isSelected).length === 1}
                  onChange={(e) => {
                    const newDataTabel = [...dataTabel];
                    newDataTabel[idx].isSelected = !newDataTabel[idx].isSelected;
                    setDataTabel(newDataTabel);
                  }} />
                <div className="fs-12 text-uppercase">
                  <input
                    value={item.label}
                    onChange={(e) => {
                      setDataTabel((prevData) => prevData.map((itm) => (itm.id === item.id ? { ...itm, label: e.target.value } : itm)));
                    }}/>
                </div>
              </div>
            );
          })}
        </ModalBody>
        <div className="modal-footer">
          <div className="hstack gap-2 justify-content-end">
            <button type="button" className="btn btn-light" onClick={toggle}>
              Close
            </button>
            <button type="submit" className="btn btn-info" onClick={handlePrint}>
              Pdf&nbsp;
              {loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
            </button>
            <button type="submit" className="btn btn-info" onClick={handleDownloadExcel}>
              Excel
            </button>
          </div>
        </div>
      </Modal>
      <PrintDoc innerRef={printRef} data={excelData} />
    </>
  );
};

export default ExportBudgetDoc;
